window.$ = window.jQuery = require('jquery');

$(function () {

   $('#rd-close-pop').on('click', function () {
       $('#rd-pop-box').fadeOut()
   })
})
